/* ============================================================================
   LA CAVERNE DE NOËL — animations
   À installer dans : assets/caverne-noel.js
   Chargé sur toutes les pages depuis layout/theme.liquid.

   Deux comportements distincts :
   - la gerbe au clic sur l'entrée de menu fonctionne partout, puisque le
     visiteur clique depuis n'importe quelle page ;
   - la neige ne s'active que sur la page de la Caverne.
   ============================================================================ */

(function () {
  'use strict';

  var CHEMIN_CAVERNE = 'caverne';
  var surLaPage =
    window.location.pathname.toLowerCase().indexOf(CHEMIN_CAVERNE) !== -1;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (surLaPage) {
    document.documentElement.classList.add('caverne-noel');
  }

  /* -------------------------------------------------------------------------
     1. Gerbe de particules au clic sur l'entrée de menu
     ------------------------------------------------------------------------- */

  var TEINTES = ['#1b4332', '#2d6a4f', '#40916c', '#b08d3f', '#9b2226'];
  var DUREE = 620;

  function gerbe(x, y) {
    var couche = document.createElement('div');
    couche.className = 'caverne-gerbe';
    couche.style.left = x + 'px';
    couche.style.top = y + 'px';
    document.body.appendChild(couche);

    var total = 20;
    for (var i = 0; i < total; i++) {
      var p = document.createElement('span');
      var angle = (Math.PI * 2 * i) / total + (Math.random() - 0.5) * 0.35;
      var distance = 42 + Math.random() * 54;
      var taille = 6 + Math.random() * 6;

      p.style.setProperty('--dx', Math.cos(angle) * distance + 'px');
      p.style.setProperty('--dy', Math.sin(angle) * distance + 'px');
      p.style.setProperty('--delai', Math.random() * 60 + 'ms');
      p.style.width = taille + 'px';
      p.style.height = taille + 'px';
      p.style.background = TEINTES[Math.floor(Math.random() * TEINTES.length)];
      couche.appendChild(p);
    }

    window.setTimeout(function () {
      if (couche.parentNode) couche.parentNode.removeChild(couche);
    }, DUREE + 300);
  }

  function ecouteMenu() {
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest) return;
        var lien = e.target.closest('a[href*="' + CHEMIN_CAVERNE + '"]');
        if (!lien) return;

        var r = lien.getBoundingClientRect();
        gerbe(r.left + r.width / 2, r.top + r.height / 2);

        // Le clic ouvre la page : on laisse l'animation se jouer brièvement
        // avant de suivre le lien. Les ouvertures dans un nouvel onglet et
        // les clics du milieu ne sont jamais retardés.
        var neutre =
          e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ||
          lien.target === '_blank' || e.button !== 0;

        if (neutre) return;

        var destination = lien.getAttribute('href');
        if (!destination) return;

        e.preventDefault();
        window.setTimeout(function () {
          window.location.href = destination;
        }, 340);
      },
      true
    );
  }

  if (!reduced) ecouteMenu();

  /* -------------------------------------------------------------------------
     2. Neige, sur la page de la Caverne uniquement
     ------------------------------------------------------------------------- */

  if (!surLaPage || reduced) return;

  var canvas, ctx, flocons = [], largeur = 0, hauteur = 0, raf = null;

  function densite() {
    var base = Math.round((window.innerWidth * window.innerHeight) / 16000);
    return Math.max(40, Math.min(150, base));
  }

  function nouveauFlocon() {
    var r = Math.random();
    return {
      x: Math.random() * largeur,
      y: Math.random() * hauteur,
      rayon:
        r < 0.6 ? 0.8 + Math.random() * 0.7
        : r < 0.9 ? 1.5 + Math.random() * 0.9
        : 2.4 + Math.random() * 1.1,
      vitesse: 0.25 + Math.random() * 0.75,
      derive: (Math.random() - 0.5) * 0.45,
      phase: Math.random() * Math.PI * 2,
      balance: 0.3 + Math.random() * 0.7,
      opacite: 0.45 + Math.random() * 0.5
    };
  }

  function redimensionne() {
    var ratio = window.devicePixelRatio || 1;
    largeur = window.innerWidth;
    hauteur = window.innerHeight;
    canvas.width = Math.floor(largeur * ratio);
    canvas.height = Math.floor(hauteur * ratio);
    canvas.style.width = largeur + 'px';
    canvas.style.height = hauteur + 'px';
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

    var cible = densite();
    while (flocons.length < cible) flocons.push(nouveauFlocon());
    if (flocons.length > cible) flocons.length = cible;
  }

  function dessine() {
    ctx.clearRect(0, 0, largeur, hauteur);

    for (var i = 0; i < flocons.length; i++) {
      var f = flocons[i];

      f.y += f.vitesse;
      f.phase += 0.012;
      f.x += f.derive + Math.sin(f.phase) * f.balance * 0.35;

      if (f.y - f.rayon > hauteur) {
        f.y = -f.rayon;
        f.x = Math.random() * largeur;
      }
      if (f.x < -10) f.x = largeur + 10;
      if (f.x > largeur + 10) f.x = -10;

      ctx.beginPath();
      ctx.arc(f.x, f.y, f.rayon, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, ' + f.opacite + ')';
      ctx.fill();
    }

    raf = window.requestAnimationFrame(dessine);
  }

  function demarre() {
    if (raf === null) raf = window.requestAnimationFrame(dessine);
  }

  function arrete() {
    if (raf !== null) {
      window.cancelAnimationFrame(raf);
      raf = null;
    }
  }

  function initNeige() {
    canvas = document.createElement('canvas');
    canvas.id = 'caverne-neige';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    ctx = canvas.getContext('2d');
    if (!ctx) return;

    redimensionne();
    demarre();

    var minuteur = null;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(redimensionne, 200);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) arrete();
      else demarre();
    });
  }

  /* -------------------------------------------------------------------------
     3. Père Noël dans l'angle inférieur gauche
     ------------------------------------------------------------------------- */

  var SVG_PERE_NOEL = [
    '<svg viewBox="0 0 200 290" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">',
    '<g class="pn-corps">',

    // Manteau
    '<path d="M62 176 Q62 156 100 156 Q138 156 138 176 L146 268 Q100 278 54 268 Z" fill="#9b2226"/>',
    // Fourrure du bas
    '<path d="M54 268 Q100 278 146 268 L148 280 Q100 290 52 280 Z" fill="#f6f3ea"/>',
    // Ceinture
    '<rect x="56" y="212" width="88" height="20" rx="4" fill="#2a2622"/>',
    '<rect x="90" y="212" width="20" height="20" rx="3" fill="#b08d3f"/>',

    // Tête
    '<g class="pn-tete">',
    // Barbe
    '<path d="M66 112 Q60 172 100 174 Q140 172 134 112 Z" fill="#f6f3ea"/>',
    '<circle cx="74" cy="150" r="15" fill="#f6f3ea"/>',
    '<circle cx="126" cy="150" r="15" fill="#f6f3ea"/>',
    '<circle cx="100" cy="162" r="17" fill="#f6f3ea"/>',
    // Visage
    '<path d="M70 92 Q70 62 100 62 Q130 62 130 92 L130 116 Q130 138 100 138 Q70 138 70 116 Z" fill="#f0c9a8"/>',
    // Yeux
    '<circle cx="86" cy="96" r="6.5" fill="#ffffff"/>',
    '<circle cx="114" cy="96" r="6.5" fill="#ffffff"/>',
    '<circle class="pn-pupille" cx="86" cy="96" r="3.4" fill="#2a2622"/>',
    '<circle class="pn-pupille" cx="114" cy="96" r="3.4" fill="#2a2622"/>',
    // Nez
    '<circle cx="100" cy="110" r="8" fill="#e0a184"/>',
    // Bouches
    '<path class="pn-bouche-neutre" d="M90 129 Q100 135 110 129" stroke="#8a5a48" stroke-width="3" fill="none" stroke-linecap="round"/>',
    '<path class="pn-bouche-joie" d="M87 127 Q100 145 113 127 Q100 134 87 127 Z" fill="#8a3a3a"/>',
    // Moustache
    '<path d="M76 117 Q89 110 100 117 Q111 110 124 117 Q111 127 100 121 Q89 127 76 117 Z" fill="#ffffff"/>',
    // Bonnet
    '<path d="M66 76 Q66 40 100 40 Q134 40 134 76 Z" fill="#9b2226"/>',
    '<path d="M100 40 Q126 34 140 20" stroke="#9b2226" stroke-width="17" fill="none" stroke-linecap="round"/>',
    '<rect x="62" y="72" width="76" height="15" rx="7" fill="#f6f3ea"/>',
    '<circle cx="144" cy="17" r="11" fill="#f6f3ea"/>',
    '</g>',

    // Bras gauche
    '<g class="pn-bras-g">',
    '<rect x="40" y="168" width="24" height="76" rx="12" fill="#9b2226"/>',
    '<rect x="40" y="230" width="24" height="14" rx="7" fill="#f6f3ea"/>',
    '<circle cx="52" cy="254" r="14" fill="#2a2622"/>',
    '</g>',

    // Bras droit
    '<g class="pn-bras-d">',
    '<rect x="136" y="168" width="24" height="76" rx="12" fill="#9b2226"/>',
    '<rect x="136" y="230" width="24" height="14" rx="7" fill="#f6f3ea"/>',
    '<circle cx="148" cy="254" r="14" fill="#2a2622"/>',
    '</g>',

    '</g>',
    '</svg>'
  ].join('');

  var perenoel = null, tete = null, pupilles = null, minuteurJoie = null;

  function placePereNoel() {
    perenoel = document.createElement('div');
    perenoel.id = 'caverne-pere-noel';
    perenoel.setAttribute('aria-hidden', 'true');
    perenoel.innerHTML = SVG_PERE_NOEL;
    document.body.appendChild(perenoel);

    tete = perenoel.querySelector('.pn-tete');
    pupilles = perenoel.querySelectorAll('.pn-pupille');

    document.addEventListener('mousemove', suitCurseur);
  }

  function suitCurseur(e) {
    if (!tete) return;

    var boite = perenoel.getBoundingClientRect();
    // La tête occupe environ le tiers supérieur du personnage
    var cx = boite.left + boite.width / 2;
    var cy = boite.top + boite.height * 0.33;

    var dx = e.clientX - cx;
    var dy = e.clientY - cy;

    // Inclinaison bornée, pour rester naturel
    var angle = Math.atan2(dy, dx) * (180 / Math.PI);
    var incline = Math.max(-16, Math.min(16, dx / 26));
    var monte = Math.max(-5, Math.min(5, dy / 90));

    tete.style.transform =
      'rotate(' + incline + 'deg) translate(' + (incline * 0.28) + 'px, ' + monte + 'px)';

    // Les pupilles suivent avec une amplitude plus large
    var px = Math.max(-2.6, Math.min(2.6, dx / 130));
    var py = Math.max(-2.2, Math.min(2.2, dy / 150));
    for (var i = 0; i < pupilles.length; i++) {
      pupilles[i].style.transform = 'translate(' + px + 'px, ' + py + 'px)';
    }
  }

  function celebre() {
    if (!perenoel) return;
    perenoel.classList.add('pn-joie');
    window.clearTimeout(minuteurJoie);
    minuteurJoie = window.setTimeout(function () {
      perenoel.classList.remove('pn-joie');
    }, 1800);
  }

  /* Détection de l'ajout au panier : les thèmes passent par /cart/add,
     que ce soit en fetch ou en XMLHttpRequest. On observe les deux sans
     interférer avec la requête elle-même. */

  function ecouteAjoutPanier() {
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function') {
      window.fetch = function () {
        var url = arguments[0];
        var chemin = typeof url === 'string' ? url : (url && url.url) || '';
        var resultat = fetchOriginal.apply(this, arguments);
        if (chemin.indexOf('/cart/add') !== -1) {
          resultat.then(function (r) {
            if (r && r.ok) celebre();
          }).catch(function () {});
        }
        return resultat;
      };
    }

    var openOriginal = window.XMLHttpRequest &&
      window.XMLHttpRequest.prototype.open;
    if (openOriginal) {
      window.XMLHttpRequest.prototype.open = function (methode, url) {
        this.addEventListener('load', function () {
          if (String(url).indexOf('/cart/add') !== -1 && this.status < 400) {
            celebre();
          }
        });
        return openOriginal.apply(this, arguments);
      };
    }

    // Les thèmes récents émettent aussi un événement dédié
    document.addEventListener('cart:updated', celebre);
    document.addEventListener('cart:refresh', celebre);
  }

  function initPereNoel() {
    placePereNoel();
    ecouteAjoutPanier();
  }

  // Chaque module est isolé : la panne de l'un ne doit jamais empêcher
  // les autres de fonctionner.
  function demarrer() {
    try {
      initNeige();
    } catch (e) {
      if (window.console) console.warn('Caverne : neige indisponible', e);
    }
    try {
      initPereNoel();
    } catch (e) {
      if (window.console) console.warn('Caverne : père Noël indisponible', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();